<div class="main">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Diagnostic Debug Images
        <span class="subtitle"><i>Scan ID:</i> {{scanId}}</span>
        <button mat-raised-button class="back" ecaThrottleClick (throttleClick)="back()">Back</button>
      </mat-card-title>

    </mat-card-header>

    <mat-accordion>
      @for (debugImage of debugUrls$ | async; track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{debugImage.name}}</mat-panel-title>
          </mat-expansion-panel-header>
          <img class="debug-image" src="{{debugImage.url}}">
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-card>
</div>
